import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  static targets = [ 'input', 'result' ]

  sendRequest() {
    fetch(this.url)
      .then(response => response.text())
      .then(html => {
        this.resultTarget.innerHTML = html;
      });
  }

  get url() {
    return `${this.data.get('requestUrl')}?key=${this.inputTarget.value}`
  }
}